import { DeleteButton, SaveButton, Toolbar } from "react-admin";

export const ItasToolbar = () => (
    <Toolbar>
        <SaveButton label="Salva" />
        <div style={{ height: '100%', flexGrow: '1' }}></div>
        <DeleteButton label="Elimina"  />
    </Toolbar>
)